// src/core/services/store/index.js
import { createStore } from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import modal from "./modal.module";
import job from "./job.module";
import resume from "./resume.module";
import menu from "./menu.module";
import screenSize from "./screenSize.module";

const store = createStore({
  modules: {
    modal,
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    job,
    resume,
    menu,
    screenSize,
  },
});

window.addEventListener("resize", () => {
  // keep same action name as before
  store.dispatch("updateScreenSize");
});

export default store;
